import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Component } from "react";
import { Dropdown, Menu, Tooltip } from "./index.js";
/**
 * Toolbar button for the toolbar component.
 *
 * @returns
 */ export class ToolbarButton extends Component {
    render() {
        // @TODO <Menu onClick={handleMenuClick}
        const { visible = true, content, cssClasses, toolTipTitle, toolTipText, disabled, menu, toolTipPlacement, dropdownPlacement, modifier } = this.props;
        const className = classNames(cssClasses, "aiot-tooltip", {
            "aiot-disabled": disabled
        });
        const bodyAttr = {
            href: "#",
            className,
            disabled,
            onClick: this.handleClick
        };
        if (!visible) {
            return null;
        }
        let body = /*#__PURE__*/ _jsx("a", {
            ...bodyAttr,
            children: content
        });
        modifier && (body = modifier(body, this.props));
        // Make tooltip
        if (toolTipTitle && toolTipText) {
            body = /*#__PURE__*/ _jsx(Tooltip, {
                placement: toolTipPlacement ? toolTipPlacement : menu ? "rightTop" : "bottom",
                title: toolTipTitle,
                content: toolTipText,
                children: body
            });
        }
        // Make dropdown with menu items
        if (menu) {
            let overlay = menu;
            if (menu.map) {
                const overlayMenu = menu.map((param)=>{
                    let { key, label, toolTipTitle, toolTipText, ...rest } = param;
                    const menuItem = /*#__PURE__*/ _jsx(Menu.Item, {
                        ...rest,
                        children: label
                    }, key);
                    return toolTipTitle && toolTipText ? /*#__PURE__*/ _jsx(Tooltip, {
                        overlayClassName: "aiot-toolbar-menu",
                        placement: "rightTop",
                        title: toolTipTitle,
                        content: toolTipText,
                        children: menuItem
                    }) : menuItem;
                });
                overlay = /*#__PURE__*/ _jsx(Menu, {
                    children: overlayMenu
                });
            }
            body = // @ts-expect-error outdated @types/react
            /*#__PURE__*/ _jsx(Dropdown, {
                placement: dropdownPlacement ? dropdownPlacement : "bottomRight",
                overlay: overlay,
                children: body
            });
        }
        return body;
    }
    constructor(...args){
        super(...args);
        this.handleClick = (e)=>{
            if (!this.props.disabled) {
                this.props.onClick && this.props.onClick(this.props);
            }
            e.preventDefault();
        };
    }
}
